import styled from "styled-components";

export const Page = styled.div`
  background: #0e1a24;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  color: #f7f8fa;
`;

export const HeaderBar = styled.header`
  position: sticky;
  top: 0;
  z-index: 20;
  background: #0e1a24;
  border-bottom: 1px solid #2a2a2a;
`;

export const HeaderInner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
`;

export const LogoLink = styled.a`
  display: inline-flex;
  align-items: center;
  width: 160px;
`;

export const LogoImg = styled.img`
  width: 100%;
  height: auto;
`;

export const Main = styled.main`
  flex: 1;
`;

export const Article = styled.article`
  max-width: 880px;
  margin: 0 auto;
  padding: 48px 16px 64px;
`;

export const ArticleHeader = styled.header`
  margin-bottom: 40px;
`;

export const Title = styled.h1`
  font-size: 36px;
  line-height: 42px;
  font-weight: 700;
  letter-spacing: -0.01em;
  margin: 0;

  @media screen and (max-width: 640px) {
    font-size: 30px;
    line-height: 36px;
  }
`;

export const Content = styled.div`
  font-size: 16px;
  line-height: 26px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  h2 {
    font-size: 22px;
    line-height: 30px;
    margin: 24px 0 12px;
    font-weight: 700;
  }

  p {
    margin: 0 0 16px;
  }

  ul {
    margin: 0 0 16px 20px;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  li {
    margin: 0;
  }

  strong {
    font-weight: 700;
  }

  em {
    font-style: italic;
  }
`;
